import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { MultiSelect } from 'primereact/multiselect';
import CBModal from '../../shared/CBModal';
import TextWithLinebreaks from '../../shared/TextWithLinebreaks';
import ImageCarouselModal from '../../VehicleDetailsView/VehicleDetailsComponents/ImageCarouselModal';
import AddMessageResponseModal from '../../VehicleDetailsView/VehicleDetailsComponents/AddMessageResponseModal';
import CBButtonSubmit from '../../shared/CBButtonSubmit';
import { canResolveApprovalMessage, SERVICE_CHAIN } from '../../../utils/utils';
import { getMessagingRoleLabel } from '../../../utils/messagingRoles';

class ChainMessageDetailModal extends React.Component {
  state = {
    imageIndex: 0,
    imageModalIsOpen: false,
    // The image set the lightbox is showing — the message's own images or
    // one response's images, whichever thumbnail was clicked.
    imageModalImages: null,
    responseModalIsOpen: false,
    // 'approved' / 'rejected' preselects the decision in the reply dialog.
    responsePresetDecision: '',
    forwardModalIsOpen: false,
    forwardWorkshops: [],
    forwardOrganizations: [],
  };

  openImageModal = (images, index) => {
    this.setState({ imageModalIsOpen: true, imageIndex: index, imageModalImages: images });
  };

  hideImageModal = () => {
    this.setState({ imageModalIsOpen: false });
  };

  openResponseModal = (presetDecision) => {
    this.setState({
      responseModalIsOpen: true,
      responsePresetDecision: typeof presetDecision === 'string' ? presetDecision : '',
    });
  };

  closeResponseModal = () => {
    this.setState({ responseModalIsOpen: false, responsePresetDecision: '' });
  };

  openForwardModal = () => {
    this.setState({ forwardModalIsOpen: true, forwardWorkshops: [], forwardOrganizations: [] });
  };

  closeForwardModal = () => {
    this.setState({ forwardModalIsOpen: false });
  };

  submitForward = () => {
    var _this = this;
    var forwardMessage = this.props.forwardMessage;
    var message = this.props.message;
    var forwardWorkshops = this.state.forwardWorkshops;
    var forwardOrganizations = this.state.forwardOrganizations;

    if (forwardMessage && (forwardWorkshops.length > 0 || forwardOrganizations.length > 0)) {
      forwardMessage(message.id, {
        recipient_workshops: forwardWorkshops,
        recipient_organizations: forwardOrganizations,
      }).then(function () {
        _this.closeForwardModal();
      });
    }
  };

  getAvailableForwardWorkshops = () => {
    var message = this.props.message;
    var chainMemberships = this.props.chainMemberships;
    if (!chainMemberships) return [];
    var existingWsIds = {};
    if (message.recipients) {
      message.recipients.forEach(function (r) {
        if (r.recipient_type === 'workshop' && r.recipient_workshop) {
          existingWsIds[r.recipient_workshop] = true;
        }
      });
    }
    return chainMemberships
      .filter(function (m) { return m.workshop && !existingWsIds[m.workshop.id]; })
      .map(function (m) { return { label: m.workshop.name, value: m.workshop.id }; });
  };

  getAvailableForwardOrganizations = () => {
    // Forwarding to fleet customer organizations is the chain's call only —
    // a workshop forwards within the chain (to other workshops). The backend
    // refuses it too; hiding the picker keeps the workshop from even seeing
    // the chain's customer list here.
    var service = this.props.service || this.props.appService;
    if (service !== SERVICE_CHAIN) return [];
    var message = this.props.message;
    var chainCareServices = this.props.chainCareServices;
    if (!chainCareServices) return [];
    var existingOrgIds = {};
    if (message.recipients) {
      message.recipients.forEach(function (r) {
        if (r.recipient_type === 'organization' && r.recipient_organization) {
          existingOrgIds[r.recipient_organization] = true;
        }
      });
    }
    var seen = {};
    return chainCareServices
      .filter(function (cs) { return cs.organization && !existingOrgIds[cs.organization] && !seen[cs.organization] && (seen[cs.organization] = true); })
      .map(function (cs) { return { label: cs.organization_name || ('Yritys #' + cs.organization), value: cs.organization }; });
  };

  getMessageTypeBadge = () => {
    const { message, t } = this.props;
    if (message.message_type === 'approval_request') {
      return (
        <span style={styles.approvalRequestBadge}>{t('typeApprovalRequest')}</span>
      );
    }
    if (message.message_type === 'customer_approval') {
      return (
        <span style={styles.approvalRequestBadge}>{t('typeCustomerApproval')}</span>
      );
    }
    if (message.message_type === 'availability_inquiry') {
      return (
        <span style={styles.availabilityInquiryBadge}>{t('typeAvailabilityInquiry')}</span>
      );
    }
    if (message.message_type === 'chain_message') {
      return (
        <span style={styles.chainMessageBadge}>{t('typeChainMessage')}</span>
      );
    }
    return (
      <span style={styles.vehicleMessageBadge}>{t('typeVehicleMessage')}</span>
    );
  };

  getApprovalStatusBadge = () => {
    const { message, t } = this.props;
    var isApprovalType = message.message_type === 'approval_request'
      || message.message_type === 'customer_approval';
    if (!isApprovalType || !message.approval_status) {
      return null;
    }
    var badgeColors = {
      pending: { backgroundColor: '#e67e22', color: '#fff' },
      approved: { backgroundColor: '#27ae60', color: '#fff' },
      rejected: { backgroundColor: '#e74c3c', color: '#fff' },
    };
    var labels = {
      pending: t('approvalPending'),
      approved: t('approvalApproved'),
      rejected: t('approvalRejected'),
    };
    return (
      <span style={{ ...styles.badgeBase, ...badgeColors[message.approval_status] }}>
        {labels[message.approval_status] || message.approval_status}
      </span>
    );
  };

  getRecipientNames = () => {
    var message = this.props.message;
    var t = this.props.t;
    if (!message.recipients || !message.recipients.length) {
      return null;
    }
    return message.recipients.map(function(r) {
      if (r.recipient_role) {
        return r.display_name + ' (' + getMessagingRoleLabel(t, r.recipient_role) + ')';
      }
      return r.display_name;
    }).join(', ');
  };

  renderLinkedVehicles = () => {
    var message = this.props.message;
    var t = this.props.t;
    if (message.message_type !== 'approval_request' && message.message_type !== 'customer_approval') return null;

    var hasVehicles = message.linked_vehicles && message.linked_vehicles.length > 0;
    var hasReservations = message.linked_reservations && message.linked_reservations.length > 0;

    if (!hasVehicles && !hasReservations) return null;

    return (
      <div style={styles.vehiclesCard}>
        <div style={styles.vehiclesCardTitle}>{t('linkedVehicles')}</div>
        {hasReservations ? (
          message.linked_reservations.map(function(r) {
            return (
              <div key={r.id} style={styles.vehicleRow}>
                <span style={styles.vehicleRegNr}>{r.reg_nr}</span>
                <span style={styles.vehicleDetails}>
                  {r.workshop_name || ''}
                  {r.start ? (' \u00B7 ' + moment(r.start).format('DD.MM.YYYY HH:mm')) : ''}
                  {r.description ? (' \u00B7 ' + r.description) : ''}
                </span>
              </div>
            );
          })
        ) : (
          message.linked_vehicles.map(function(v) {
            return (
              <div key={v.id} style={styles.vehicleRow}>
                <span style={styles.vehicleRegNr}>{v.registration_number}</span>
                <span style={styles.vehicleDetails}>
                  {[v.manufacturer, v.model_name].filter(Boolean).join(' ')}
                </span>
              </div>
            );
          })
        )}
      </div>
    );
  };

  renderForwardModal = () => {
    var t = this.props.t;
    var forwardModalIsOpen = this.state.forwardModalIsOpen;
    var forwardWorkshops = this.state.forwardWorkshops;
    var forwardOrganizations = this.state.forwardOrganizations;
    var _this = this;

    if (!forwardModalIsOpen) return null;

    var wsOptions = this.getAvailableForwardWorkshops();
    var orgOptions = this.getAvailableForwardOrganizations();
    var isValid = forwardWorkshops.length > 0 || forwardOrganizations.length > 0;

    return (
      <CBModal
        modalIsOpen={forwardModalIsOpen}
        closeModal={this.closeForwardModal}
        overlayZIndex={this.props.overlayZIndex}
        title={t('forwardMessage')}
        submitForm={this.submitForward}
        submitText={t('forward')}
        isValid={isValid}
        cancelText={t('cancel', { defaultValue: 'Peruuta' })}
      >
        <div style={{ padding: '0 24px 16px 24px' }}>
          <p style={styles.forwardLabel}>{t('forwardSelectRecipients')}</p>
          {wsOptions.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <p style={styles.forwardFieldLabel}>{t('recipientWorkshops', { ns: 'MessageListView' })}</p>
              <MultiSelect
                value={forwardWorkshops}
                options={wsOptions}
                onChange={function (e) { _this.setState({ forwardWorkshops: e.value }); }}
                placeholder={t('selectWorkshops', { ns: 'MessageListView' })}
                style={{ width: '100%' }}
              />
            </div>
          )}
          {orgOptions.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <p style={styles.forwardFieldLabel}>{t('recipientOrganizations', { ns: 'MessageListView' })}</p>
              <MultiSelect
                value={forwardOrganizations}
                options={orgOptions}
                onChange={function (e) { _this.setState({ forwardOrganizations: e.value }); }}
                placeholder={t('selectOrganizations', { ns: 'MessageListView' })}
                style={{ width: '100%' }}
              />
            </div>
          )}
        </div>
      </CBModal>
    );
  };

  render() {
    var _this = this;
    var props = this.props;
    var message = props.message;
    var modalIsOpen = props.modalIsOpen;
    var closeModal = props.closeModal;
    var approveMessage = props.approveMessage;
    var t = props.t;
    var state = this.state;
    var imageIndex = state.imageIndex;
    var imageModalIsOpen = state.imageModalIsOpen;
    var responseModalIsOpen = state.responseModalIsOpen;

    if (!message) return null;

    // approval_request is resolved by the chain; customer_approval by the fleet
    // customer only (read-only for the chain). Callers may pass the portal
    // explicitly; otherwise the one the app is running as is used.
    var isPendingApproval = canResolveApprovalMessage(message, props.service || props.appService);

    var isChainMessage = message.message_type === 'chain_message'
      || message.message_type === 'approval_request'
      || message.message_type === 'customer_approval';

    var senderContext = message.sender_context_display || message.sender_workshop_name;
    var senderDisplay = senderContext
      ? message.user_display + ' \u2014 ' + senderContext
      : message.user_display;

    var recipientNames = this.getRecipientNames();

    var hasResolvedInfo = (message.message_type === 'approval_request'
      || message.message_type === 'customer_approval')
      && message.approval_status !== 'pending'
      && (message.resolved_by_display || message.resolved_at);

    return (
      <React.Fragment>
        <CBModal
          modalIsOpen={modalIsOpen}
          closeModal={closeModal}
          overlayZIndex={props.overlayZIndex}
          title={message.subject}
          submitForm={this.openResponseModal}
          submitText={t('replyButton')}
          isValid
          hideCancelButton
        >
          <div style={styles.body}>
            <div style={styles.badgeRow}>
              {this.getMessageTypeBadge()}
              {this.getApprovalStatusBadge()}
            </div>

            {/* The decision is the reader's main job on a pending request, so it
                sits first — not below the message text where it needed scrolling. */}
            {isPendingApproval && (
              <div style={styles.actionButtons}>
                <div
                  className='opacity-on-hover'
                  style={styles.approveButton}
                  onClick={function() { if (approveMessage) approveMessage(); }}
                >
                  {t('approveButton')}
                </div>
                <div
                  className='opacity-on-hover'
                  style={styles.rejectButton}
                  onClick={function() { _this.openResponseModal('rejected'); }}
                >
                  {t('rejectButton')}
                </div>
                <div style={styles.actionHint}>{t('decisionHint')}</div>
              </div>
            )}

            <div style={styles.infoCard}>
              <div style={styles.infoRow}>
                <div style={styles.infoLabel}>{t('senderLabel')}</div>
                <div style={styles.infoValue}>{senderDisplay}</div>
              </div>
              <div style={styles.infoRow}>
                <div style={styles.infoLabel}>{t('dateLabel', { defaultValue: 'Päivämäärä' })}</div>
                <div style={styles.infoValue}>{moment(message.created_at).format('D.M.YYYY HH:mm')}</div>
              </div>
              {message.vehicle_registration_number && (
                <div style={styles.infoRow}>
                  <div style={styles.infoLabel}>{t('vehicleLabel', { defaultValue: 'Ajoneuvo' })}</div>
                  <div style={styles.infoValue}>
                    {message.vehicle_registration_number}
                    {message.vehicle_model ? (' — ' + message.vehicle_model) : ''}
                  </div>
                </div>
              )}
              {recipientNames && (
                <div style={styles.infoRow}>
                  <div style={styles.infoLabel}>{t('recipientsLabel')}</div>
                  <div style={styles.infoValue}>{recipientNames}</div>
                </div>
              )}
              {hasResolvedInfo && (
                <div style={styles.infoRow}>
                  <div style={styles.infoLabel}>{t('resolvedByLabel')}</div>
                  <div style={styles.infoValue}>
                    {message.resolved_by_display || ''}
                    {message.resolved_at ? (' \u2014 ' + moment(message.resolved_at).format('D.M.YYYY HH:mm')) : ''}
                  </div>
                </div>
              )}
            </div>

            {this.renderLinkedVehicles()}

            {message.task && (
              <div style={styles.vehiclesCard}>
                <div style={styles.vehiclesCardTitle}>{t('linkedTask', { defaultValue: 'Tehtävä' })}</div>
                <div style={{ fontSize: 13, padding: '4px 0' }}>
                  <strong>{message.task.title}</strong>
                  {message.task.due_at && (
                    <span style={{ color: '#666', marginLeft: 8 }}>
                      {moment(message.task.due_at).format('D.M.YYYY')}
                    </span>
                  )}
                </div>
              </div>
            )}

            <div style={styles.messageCard}>
              <div style={styles.messageCardTitle}>{t('messageTextLabel', { defaultValue: 'Viesti' })}</div>
              <div style={styles.messageText}>
                <TextWithLinebreaks text={message.text || ''} />
              </div>
              <ImageCarouselModal
                show={imageModalIsOpen}
                handleClose={this.hideImageModal}
                imageIndex={imageIndex}
                images={this.state.imageModalImages || []}
              />
              {message.images && message.images.length > 0 && (
                <div style={styles.imagesSection}>
                  <div style={styles.imageGrid}>
                    {message.images.map(function(image, index) {
                      return (
                        <div
                          key={image.id}
                          style={{
                            ...styles.squareImage,
                            backgroundImage: 'url(' + image.image + ')',
                          }}
                          onClick={function() { _this.openImageModal(message.images, index); }}
                        />
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {isChainMessage && (
              <div style={{ marginBottom: 16 }}>
                <CBButtonSubmit
                  onClick={this.openForwardModal}
                  text={t('forwardMessage')}
                  style={styles.forwardButton}
                  textStyle={styles.forwardButtonText}
                />
              </div>
            )}

            <div style={styles.responsesSection}>
              <div style={styles.responsesHeading}>
                {t('responsesSectionTitle')} ({message.responses ? message.responses.length : 0})
              </div>
              {message.responses && message.responses.length > 0 ? (
                message.responses.map(function(response) {
                  return (
                    <div key={response.id} style={styles.responseCard}>
                      <div style={styles.responseCardHeader}>
                        <span style={styles.responseCardUser}>
                          {response.user_display}
                          {response.sender_context_display && (
                            <span style={styles.responseCardContext}>{' \u2014 '}{response.sender_context_display}</span>
                          )}
                        </span>
                        <span style={styles.responseCardDate}>{moment(response.created_at).format('D.M.YYYY HH:mm')}</span>
                      </div>
                      <div style={styles.responseCardText}>
                        <TextWithLinebreaks text={response.text || ''} />
                      </div>
                      {response.images && response.images.length > 0 && (
                        <div style={styles.imageGrid}>
                          {response.images.map(function(image, index) {
                            return (
                              <div
                                key={image.id}
                                style={{
                                  ...styles.squareImage,
                                  backgroundImage: 'url(' + image.image + ')',
                                }}
                                onClick={function() { _this.openImageModal(response.images, index); }}
                              />
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div style={styles.noResponses}>{t('noResponses')}</div>
              )}
            </div>
          </div>
        </CBModal>

        {responseModalIsOpen && (
          <AddMessageResponseModal
            modalIsOpen={responseModalIsOpen}
            closeModal={this.closeResponseModal}
            message={message}
            overlayZIndex={props.overlayZIndex}
            presetDecision={state.responsePresetDecision}
            isListRequest
          />
        )}

        {this.renderForwardModal()}
      </React.Fragment>
    );
  }
}

var styles = {
  badgeBase: {
    padding: '3px 10px',
    borderRadius: 4,
    fontSize: 11,
    fontFamily: 'TitilliumWeb-Bold',
    display: 'inline-block',
    marginRight: 6,
  },
  chainMessageBadge: {
    padding: '3px 10px',
    borderRadius: 4,
    fontSize: 11,
    fontFamily: 'TitilliumWeb-Bold',
    display: 'inline-block',
    marginRight: 6,
    backgroundColor: '#0077b6',
    color: '#fff',
  },
  approvalRequestBadge: {
    padding: '3px 10px',
    borderRadius: 4,
    fontSize: 11,
    fontFamily: 'TitilliumWeb-Bold',
    display: 'inline-block',
    marginRight: 6,
    backgroundColor: '#e67e22',
    color: '#fff',
  },
  availabilityInquiryBadge: {
    padding: '3px 10px',
    borderRadius: 4,
    fontSize: 11,
    fontFamily: 'TitilliumWeb-Bold',
    display: 'inline-block',
    marginRight: 6,
    backgroundColor: '#2e86ab',
    color: '#fff',
  },
  vehicleMessageBadge: {
    padding: '3px 10px',
    borderRadius: 4,
    fontSize: 11,
    fontFamily: 'TitilliumWeb-Bold',
    display: 'inline-block',
    marginRight: 6,
    backgroundColor: '#6c757d',
    color: '#fff',
  },
  body: {
    padding: '0 24px 24px 24px',
    color: '#333',
  },
  badgeRow: {
    marginBottom: 16,
  },

  // Info card — structured label-value pairs
  infoCard: {
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
    border: '1px solid #e9ecef',
    padding: '12px 16px',
    marginBottom: 16,
  },
  infoRow: {
    display: 'flex',
    padding: '6px 0',
    borderBottom: '1px solid #f0f0f0',
    fontSize: 13,
    alignItems: 'baseline',
  },
  infoLabel: {
    width: 120,
    flexShrink: 0,
    color: '#888',
    fontSize: 12,
    fontFamily: 'TitilliumWeb-SemiBold',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  infoValue: {
    flex: 1,
    color: '#333',
    fontSize: 13,
  },

  // Linked vehicles card
  vehiclesCard: {
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
    border: '1px solid #e9ecef',
    padding: '12px 16px',
    marginBottom: 16,
  },
  vehiclesCardTitle: {
    fontSize: 12,
    fontFamily: 'TitilliumWeb-SemiBold',
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    marginBottom: 8,
  },
  vehicleRow: {
    display: 'flex',
    alignItems: 'baseline',
    padding: '5px 0',
    borderBottom: '1px solid #f0f0f0',
    fontSize: 13,
  },
  vehicleRegNr: {
    fontFamily: 'TitilliumWeb-Bold',
    color: '#0095da',
    marginRight: 10,
    flexShrink: 0,
  },
  vehicleDetails: {
    color: '#666',
    fontSize: 12,
  },

  // Message text card
  messageCard: {
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
    border: '1px solid #e9ecef',
    padding: '12px 16px',
    marginBottom: 16,
  },
  messageCardTitle: {
    fontSize: 12,
    fontFamily: 'TitilliumWeb-SemiBold',
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    marginBottom: 8,
  },
  messageText: {
    fontSize: 14,
    overflowWrap: 'break-word',
    color: '#333',
    lineHeight: '1.5',
  },
  imagesSection: {
    marginTop: 12,
  },
  imageGrid: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  squareImage: {
    width: 80,
    height: 80,
    margin: '0 8px 8px 0',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    cursor: 'pointer',
    borderRadius: 4,
  },

  // Approve / reject
  actionButtons: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
    marginBottom: 16,
  },
  actionHint: {
    fontSize: 12,
    color: '#666',
  },
  approveButton: {
    backgroundColor: '#27ae60',
    color: '#fff',
    borderRadius: 6,
    padding: '10px 24px',
    cursor: 'pointer',
    fontSize: 14,
    fontFamily: 'TitilliumWeb-SemiBold',
    textAlign: 'center',
  },
  rejectButton: {
    backgroundColor: '#e74c3c',
    color: '#fff',
    borderRadius: 6,
    padding: '10px 24px',
    cursor: 'pointer',
    fontSize: 14,
    fontFamily: 'TitilliumWeb-SemiBold',
    textAlign: 'center',
  },
  forwardButton: {
    border: '2px solid #0077b6',
    color: '#0077b6',
    backgroundColor: 'transparent',
    borderRadius: 50,
    padding: '8px 24px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  forwardButtonText: {
    fontSize: 14,
    fontWeight: 700,
    color: '#0077b6',
    padding: 0,
    marginBottom: 0,
  },

  // Forward modal
  forwardLabel: {
    fontSize: 14,
    color: '#333',
    marginBottom: 12,
  },
  forwardFieldLabel: {
    fontSize: 13,
    fontFamily: 'TitilliumWeb-SemiBold',
    color: '#333',
    marginBottom: 4,
  },

  // Responses
  responsesSection: {
    borderTop: '1px solid rgba(0, 0, 0, 0.1)',
    paddingTop: 16,
    marginBottom: 16,
  },
  responsesHeading: {
    fontSize: 16,
    fontFamily: 'TitilliumWeb-SemiBold',
    marginBottom: 12,
    color: '#333',
  },
  noResponses: {
    fontSize: 13,
    color: '#999',
  },
  responseCard: {
    backgroundColor: '#f3f3fd',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
  },
  responseCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 6,
  },
  responseCardUser: {
    fontFamily: 'TitilliumWeb-SemiBold',
    fontSize: 12,
    color: '#333',
  },
  responseCardContext: {
    fontFamily: 'TitilliumWeb-Regular',
    color: '#666',
  },
  responseCardDate: {
    fontSize: 12,
    color: '#666',
  },
  responseCardText: {
    fontSize: 14,
    color: '#333',
    overflowWrap: 'break-word',
  },
};

function mapStateToProps(state) {
  return {
    appService: state.app.service,
  };
}

export default connect(mapStateToProps)(translate('MessageListView')(ChainMessageDetailModal));
